// @flow
import type LegacyContext from 'node/lib/LegacyContext';

/**
 * Collects aspects of the Module rendering process that produce side effects
 * such as requiring the renderer to make network calls to activate Experiments
 * or trigger/complete experiences, or anything else outside the scope of the
 * rendering lifecycle.
 */
export default class SideEffects {
  queuedV2ActivateExperiment: Array<string> = [];
  queuedCompletePlacedExperience: Array<Object> = [];
  queuedTriggerPlacedExperienceIds: Array<Object> = [];
  queuedV2ExperimentGroupOverrides: Array<Object> = [];
  queuedLogTrfExperiments: Array<Object> = [];
  queuedViewPlacedExperience: Array<Object> = [];

  accumulate(other: SideEffects) {
    this.queuedV2ActivateExperiment = this.queuedV2ActivateExperiment.concat(
      other.queuedV2ActivateExperiment,
    );
    this.queuedV2ExperimentGroupOverrides = this.queuedV2ExperimentGroupOverrides.concat(
      other.queuedV2ExperimentGroupOverrides,
    );
    this.queuedViewPlacedExperience = this.queuedViewPlacedExperience.concat(
      other.queuedViewPlacedExperience,
    );
    this.queuedCompletePlacedExperience = this.queuedCompletePlacedExperience.concat(
      other.queuedCompletePlacedExperience,
    );
    this.queuedTriggerPlacedExperienceIds = this.queuedTriggerPlacedExperienceIds.concat(
      other.queuedTriggerPlacedExperienceIds,
    );
    this.queuedLogTrfExperiments = this.queuedLogTrfExperiments.concat(
      other.queuedLogTrfExperiments,
    );
  }

  // $FlowFixMe Flow v0.104.0 upgrade supression.
  static fromPlainObject(plain /*: * */) {
    const ret = new SideEffects();
    ret.queuedV2ActivateExperiment = plain.queuedV2ActivateExperiment;
    ret.queuedV2ExperimentGroupOverrides = plain.queuedV2ExperimentGroupOverrides;
    ret.queuedViewPlacedExperience = plain.queuedViewPlacedExperience;
    ret.queuedCompletePlacedExperience = plain.queuedCompletePlacedExperience;
    ret.queuedTriggerPlacedExperienceIds = plain.queuedTriggerPlacedExperienceIds;
    ret.queuedLogTrfExperiments = plain.queuedLogTrfExperiments;
    return ret;
  }
}

export type SideEffectsType = SideEffects;

export function enactSideEffects(context: LegacyContext, sideEffects: SideEffectsType) {
  for (const experimentName of sideEffects.queuedV2ActivateExperiment || []) {
    context.experiments.v2ActivateExperiment(experimentName);
  }

  for (const experimentOverride of sideEffects.queuedV2ExperimentGroupOverrides || []) {
    const experimentName = experimentOverride.name || '';
    const overrideGroup = experimentOverride.override_group || '';
    context.experiments.v2LogExperimentGroupOverride(experimentName, overrideGroup);
  }

  // TODO: verify experiences triggered properly in pure node
  for (const experience of sideEffects.queuedViewPlacedExperience || []) {
    context.experiences.experience_viewed(experience.placement_id, experience.experience_id);
  }
  for (const experience of sideEffects.queuedCompletePlacedExperience || []) {
    context.experiences.experience_completed(experience.placement_id, experience.experience_id);
  }
  for (const experience of sideEffects.queuedTriggerPlacedExperienceIds || []) {
    context.experiences.trigger_experience(experience.placement_id, experience.experience_id, {});
  }
  for (const exp of sideEffects.queuedLogTrfExperiments || []) {
    context.getSeoExperimentGroup(exp.name, exp.id);
  }

  context.flushSideEffects();
}
